<chart [options]="options"></chart>
<div class="gauge-chart-desc" *ngIf="description" placement="bottom" ngbTooltip="{{tooltipInfo}}">
  <span>{{description}}</span>
</div>
<div class="gauge-chart-name" *ngIf="chartTitle"><span>{{chartTitle}}</span></div>
<div class="gauge-chart-data-container">
  <ng-content></ng-content>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-gauge-circle-chart/achoo-gauge-circle-chart.component.html